<template>
    <div class="searchForm">
        <div class="form-group">
            <form @submit.prevent="startSearch()">
                <h3 class="sub_title">
                    <label for="searchWord">お問い合わせ検索</label>
                </h3>
                <input
                    type="text"
                    class="form-control"
                    v-model="searchWord"
                    placeholder="検索したいワードを入れてください"
                />
                <div class="button-group">
                    <button type="submit" class="btn btn-primary btn-lg">検索</button>
                </div>
            </form>
        </div>
        <vue-loading
            v-if="this.searching"
            type="spin"
            color="#333"
            :size="{ width: '50px', height: '50px' }"
        ></vue-loading>
        <div id="results" class="qa_box">
            <div v-for="(result, index) in this.results">
                <QaBox
                    v-bind:index="index"
                    v-bind:question="result.Question"
                    v-bind:answer="setCfUrl(result.Answer)"
                    v-bind:text="result.LeadText"
                    v-bind:url="result.LinkURL"
                />
            </div>
            <div
                v-if="this.isSearched && this.results.length == 0"
                class="alert alert-secondary"
            >
                <p>
                    <span>検索結果は見つかりませんでした</span>
                </p>
            </div>
        </div>
        <div class="mailLink">
            <img
                class="akiko-shokai"
                src="img/akiko_shokai_migi.png"
                alt="あきこ紹介ポーズ"
            />
            <div class="balloon-left">
                <p>問い合わせは便利なチャットボットで！</p>
            </div>
            <div class="btnBox">
                <div>
                    <button class="btn btn-primary btn-lg btn-inquiry" @click="clickFaqChat()">
                        チャットで問い合わせする
                    </button>
                    <p>
              <span class="strong caution">
                ローソンアプリ、キャンペーンについては
                <br/>24時間365日、自動応対しております。
                <br/>※オペレータ対応は平日9時-17時です。
              </span>
                    </p>
                </div>
            </div>
        </div>
        <h2 class="sub_title">よくあるお問い合わせ</h2>
        <FaqList :contactData="contactData"/>
    </div>
</template>

<script>
import {mapState, mapMutations, mapActions} from "vuex";
import {VueLoading} from "vue-loading-template";
import QaBox from "@/components/QaBox.vue";
import FaqList from "@/components/FaqList.vue";

export default {
    name: "SearchForm",
    components: {
        QaBox,
        VueLoading,
        FaqList
    },
    props: [
        'contactData',
    ],
    data() {
        return {
            searchWord: "",
        };
    },
    computed: {
        ...mapState(["results", "isSearched", "searching"]),
    },
    methods: {
        ...mapActions(["search", 'statistics']),
        async startSearch() {
            await this.statistics({type:1, value:this.searchWord});
            await this.search(this.searchWord);
            this.searchWord = '';
        },
        setCfUrl(path){
            if(path && process.env.VUE_APP_FAQ_CF_URL){
                path = path.replace(process.env.VUE_APP_FAQ_URL, process.env.VUE_APP_FAQ_CF_URL);
            }
            return path;
        },
        clickFaqChat() {
            window.open("https://www.lawson.co.jp/faq/chat/agreement.html", "window1", "width=1000px,height=1000px");
        }
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
ul {
    list-style-type: none;
    padding: 0;
}

li {
    display: inline-block;
    margin: 0 10px;
}

a {
    color: #42b983;
}

.qa_box {
    text-align: left;
    margin-top: 30px;
}

.button-group {
    padding: 10px;
}

.akiko-shokai {
    width: 130px;
    height: auto;
    vertical-align: top;
}

/* 吹き出し */
.balloon-left {
    position: relative;
    display: inline-block;
    margin: 1.5em 0 1.5em 15px;
    padding: 7px 10px;
    min-width: 120px;
    max-width: 100%;
    color: #555;
    font-size: 16px;
    background: #fff;
    border: solid 3px #555;
    box-sizing: border-box;
    border-radius: 10px;
}

.balloon-left:before {
    content: "";
    position: absolute;
    top: 50%;
    left: -47px;
    margin-top: -12px;
    border: 12px solid transparent;
    border-right: 36px solid #fff;
    z-index: 2;
}

.balloon-left:after {
    content: "";
    position: absolute;
    top: 50%;
    left: -59px;
    margin-top: -14px;
    border: 14px solid transparent;
    border-right: 42px solid #555;
    z-index: 1;
}

.balloon-left p {
    margin: 0;
    padding: 0;
}
@media screen and (max-width: 600px) {
    .akiko-shokai {
        width: 100px;
        height: auto;
        vertical-align: top;
    }
    /* 吹き出し */
    .balloon-left {
        position: relative;
        display: inline-block;
        margin: 1.5em 0 1.5em 15px;
        padding: 7px 10px;
        min-width: 120px;
        max-width: 57%;
        color: #555;
        font-size: 16px;
        background: #fff;
        border: solid 3px #555;
        box-sizing: border-box;
        border-radius: 10px;
    }
    .balloon-left:before {
        content: "";
        position: absolute;
        top: 50%;
        left: -47px;
        margin-top: -12px;
        border: 12px solid transparent;
        border-right: 36px solid #fff;
        z-index: 2;
    }
    .balloon-left:after {
        content: "";
        position: absolute;
        top: 50%;
        left: -59px;
        margin-top: -14px;
        border: 14px solid transparent;
        border-right: 42px solid #555;
        z-index: 1;
    }
    .balloon-left p {
        margin: 0;
        padding: 0;
        font-size: 14px;
    }
}

</style>
